import { TestCaseCreator } from "../testCaseCreator";
//Move
import { MoveNoArgumentTestCase } from "./moveNoArgumentTestCase";
TestCaseCreator.add("MoveNoArgumentTestCase", MoveNoArgumentTestCase);
import { MoveOneArgumentTestCase } from "./moveOneArgumentTestCase";
TestCaseCreator.add("MoveOneArgumentTestCase", MoveOneArgumentTestCase);
import { MoveTwoArgumentTestCase } from "./moveTwoArgumentTestCase";
TestCaseCreator.add("MoveTwoArgumentTestCase", MoveTwoArgumentTestCase);
import { MoveToOneArgumentTestCase } from "./moveToOneArgumentTestCase";
TestCaseCreator.add("MoveToOneArgumentTestCase", MoveToOneArgumentTestCase);
import { MoveToFindOneArgumentTestCase } from ".//moveToFindOneArgumentTestCase";
TestCaseCreator.add("MoveToFindOneArgumentTestCase", MoveToFindOneArgumentTestCase);
//Buy
import { BuyNoArgumentTestCase } from "./buyNoArgumentTestCase";
TestCaseCreator.add("BuyNoArgumentTestCase", BuyNoArgumentTestCase);
import { BuyOneArgumentTestCase } from "./buyOneArgumentTestCase";
TestCaseCreator.add("BuyOneArgumentTestCase", BuyOneArgumentTestCase);
//MoveTo
import { MoveToArgumentTestCase } from "./moveToTestCase";
TestCaseCreator.add("MoveToArgumentTestCase", MoveToArgumentTestCase);
//Log
import { LogTestCase } from "./logTestCase";
TestCaseCreator.add("LogTestCase", LogTestCase);
import { LogPiTestCase } from "./logPiTestCase";
TestCaseCreator.add("LogPiTestCase", LogPiTestCase);
//Intercept
import { InterceptTestCase } from "./interceptTestCase";
TestCaseCreator.add("InterceptTestCase", InterceptTestCase);
//InterceptGetBoatX
import { InterceptGetBoatXTestCase } from "./interceptGetBoatXTestCase";
TestCaseCreator.add("InterceptGetBoatXTestCase", InterceptGetBoatXTestCase);
import { InterceptMultiplyTestCase } from "./interceptMultiplyTestCase";
TestCaseCreator.add("InterceptMultiplyTestCase", InterceptMultiplyTestCase);
